import { action } from 'typesafe-actions';
import { ICexOpenOrder } from '../components/DexTrades/OpenOrders';
import { ICexHistoryOrder } from '../components/DexTrades/OrdersHistory';
import { ICEXOrderUpdate } from '../reducers/cex_orders';

const entity = 'cex_orders';
const GET_CEX_OPEN_ORDERS = `${entity}/GET_CEX_OPEN_ORDERS`;
const GET_CEX_OPEN_ORDERS_DONE = `${entity}/GET_CEX_OPEN_ORDERS_DONE`;
const GET_CEX_HISTORY_ORDERS = `${entity}/GET_CEX_HISTORY_ORDERS`;
const GET_CEX_HISTORY_ORDERS_DONE = `${entity}/GET_CEX_HISTORY_ORDERS_DONE`;
const GET_CEX_ORDERS = `${entity}/GET_CEX_ORDERS`;
const GET_CEX_ORDERS_FAIL = `${entity}/GET_CEX_ORDERS_FAIL`;
const CANCEL_CEX_ORDER = `${entity}/CANCEL_CEX_ORDER`;
const CANCEL_CEX_ORDER_DONE = `${entity}/CANCEL_CEX_ORDER_DONE`;
const CANCEL_CEX_ORDER_FAIL = `${entity}/CANCEL_CEX_ORDER_FAIL`;
const UPDATE_CEX_ORDER = `${entity}/UPDATE_CEX_ORDER`;

const actionGetOpenOrders = () => action(GET_CEX_OPEN_ORDERS);
const actionGetOpenOrdersDone = (data: ICexOpenOrder[]) =>
  action(GET_CEX_OPEN_ORDERS_DONE, data);
const actionGetHistoryOrders = () => action(GET_CEX_HISTORY_ORDERS);
const actionGetHistoryOrdersDone = (data: ICexHistoryOrder[]) =>
  action(GET_CEX_HISTORY_ORDERS_DONE, data);
const actionGetOrders = () => action(GET_CEX_ORDERS);
const actionGetOrdersFail = () => action(GET_CEX_ORDERS_FAIL);
const actionCancelCexOrder = (uuid: string) => action(CANCEL_CEX_ORDER, uuid);
const actionCancelCexOrderDone = (uuid: string) =>
  action(CANCEL_CEX_ORDER_DONE, uuid);
const actionCancelCexOrderFail = () => action(CANCEL_CEX_ORDER_FAIL);
const actionUpdateCexOrder = (data: ICEXOrderUpdate) =>
  action(UPDATE_CEX_ORDER, data);

export {
  GET_CEX_OPEN_ORDERS,
  GET_CEX_OPEN_ORDERS_DONE,
  GET_CEX_HISTORY_ORDERS,
  GET_CEX_HISTORY_ORDERS_DONE,
  GET_CEX_ORDERS,
  GET_CEX_ORDERS_FAIL,
  CANCEL_CEX_ORDER,
  CANCEL_CEX_ORDER_DONE,
  CANCEL_CEX_ORDER_FAIL,
  UPDATE_CEX_ORDER,
  actionGetOpenOrders,
  actionGetOpenOrdersDone,
  actionGetHistoryOrders,
  actionGetHistoryOrdersDone,
  actionGetOrders,
  actionGetOrdersFail,
  actionCancelCexOrder,
  actionCancelCexOrderDone,
  actionCancelCexOrderFail,
  actionUpdateCexOrder,
};
